function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';
const BaseComponent = _ref => {
  let {
    size,
    title,
    desc,
    titleId,
    descId,
    ...props
  } = _ref;
  let ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? ` ${descId}` : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("path", {
    d: "M15.65 10.675c.375 0 .694-.131.956-.394.263-.262.394-.581.394-.956s-.131-.694-.394-.956a1.302 1.302 0 00-.956-.394c-.375 0-.694.131-.956.394a1.302 1.302 0 00-.394.956c0 .375.131.694.394.956.262.263.581.394.956.394zm-7.3 0c.375 0 .694-.131.956-.394.263-.262.394-.581.394-.956s-.131-.694-.394-.956a1.302 1.302 0 00-.956-.394c-.375 0-.694.131-.956.394A1.302 1.302 0 007 9.325c0 .375.131.694.394.956.262.263.581.394.956.394zm3.65 6.8c1.1 0 2.113-.296 3.037-.888a5.09 5.09 0 002.013-2.412h-1.3a3.936 3.936 0 01-1.575 1.537 4.497 4.497 0 01-2.163.538c-.774 0-1.5-.175-2.175-.525a3.643 3.643 0 01-1.562-1.55H6.95a5.26 5.26 0 002.025 2.412 5.465 5.465 0 003.025.888zM12 22a9.738 9.738 0 01-3.9-.788 10.099 10.099 0 01-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.738 9.738 0 012 12c0-1.383.263-2.683.788-3.9a10.099 10.099 0 012.137-3.175c.9-.9 1.958-1.612 3.175-2.137A9.738 9.738 0 0112 2c1.383 0 2.683.263 3.9.788a10.098 10.098 0 013.175 2.137c.9.9 1.613 1.958 2.137 3.175A9.738 9.738 0 0122 12a9.738 9.738 0 01-.788 3.9 10.098 10.098 0 01-2.137 3.175c-.9.9-1.958 1.613-3.175 2.137A9.738 9.738 0 0112 22z"
  }));
};
const SvgSmile = styled(BaseComponent).withConfig({
  displayName: "Smile__SvgSmile",
  componentId: "sc-hlaya5-0"
})(["outline:none;"]);
SvgSmile.isIcon = true;
SvgSmile.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
export default SvgSmile;